<template>
  <div class="instruction">
    <div class="position-me">
      <div class="rotate-me">
        <p>
          Text authorized by FIATA.Copyright reserved © FIATA/Zurich-Switzerland
        </p>
      </div>
    </div>
    <!-- <div class="rotated">
      Text authorized by FIATA.Copyright reserved © FIATA/Zurich-Swilrzerland
    </div> -->
    <div class="form-text">
      <div class="form-text_consigner d-flex">
        <div class="form-text_consigner__left">
          <p>Consignor</p>
          <p>AITC LOGISTICS (VIETNAM) CO., LTD</p>
          <p>
            Floor 8, Phuoc Thanh Building, No. 199 Dien Bien Phu Street, Ward
            15, Binh Thanh District, Ho Chi Minh City, Vietnam
          </p>
          <p>TELL:84.28.3943.5899</p>
        </div>
        <div class="form-text_consigner__right d-flex">
          <div class="icon-left">
            <div class="vla">
            </div>
          </div>
          <div class="icon-right">
            <div class="d-flex justify-center align-center">
              <h3 class="icon-fbl">FBL</h3>
              <span class="icon-border-m"></span>
              <h4 class="icon-vn">VN</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.instruction {
  height: 100%;
  font-weight: bold;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  display: flex;
  .position-me {
    bottom: 50%;
    position: fixed;
    transform: translateX(-98%);
  }

  .rotate-me {
    transform: rotate(-90deg);
    transform-origin: right top;
    text-align: right;
  }


  .form-text {
    padding-left: 60px;
    &_consigner {
      p {
        margin-bottom: 0 !important;
      }
      &__left {
        width: 50%;

        padding-right: 20px;
        border-right: 1px solid #333;
        border-bottom: 1px solid #333;
        padding-bottom: 10px;
      }

      &__right {
        width: 50%;

        padding-left: 20px;

        border-left: 1px solid #333;
        border-bottom: 1px solid #333;
        padding-bottom: 10px;

        .icon-left {
          width: 30%;
          .vla {
            width: 80px;
            height: 80px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .icon-right {
          width: 70%;
          .icon-border-m {
            width: 100px;
            padding: 10px;
            flex-grow: 1;

            border: 1px solid #333;
          }
          .icon-fbl {
            padding-top: 10px;
            margin-right: 30px;
          }

          .icon-vn {
            border: 1px solid #333;
            padding: 10px;
            margin: 0;
            padding-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>